import styled from "styled-components";
import { Form } from "antd";
import { theme } from "../../../config";

export const ImageWrapper = styled.div`
  text-align: center;
`;

export const Image = styled.img`
  height: 60px;
  width: 60px;
  object-fit: cover;
  border-radius: 50%;
`;

export const UploadWrapper = styled.div`
  text-align: center;
  margin-top: 15px;

  @media ${theme.breakpoints.mobileAndTablet} {
    margin-top: 10px;
  }
`;

export const InputFile = styled.input`
  display: none;
`;

export const FormItemWrapper = styled.div`
  width: 202px;
  @media ${theme.breakpoints.mobile} {
    margin-right: 2px;
    margin-left: 2px;
  }
  @media ${theme.breakpoints.mobileAndTablet} {
    width: 100%;
  }
  @media ${theme.breakpoints.tablet} {
    margin-right: 6px;
    margin-left: 6px;
  }
`;

export const FormItemWrapperLeft = styled.div`
  width: 202px;
  margin-right: 16px;
  margin-left: 8px;
  @media ${theme.breakpoints.mobile} {
    margin-right: 2px;
    margin-left: 2px;
  }
  @media ${theme.breakpoints.mobileAndTablet} {
    width: 100%;
  }
  @media ${theme.breakpoints.tablet} {
    margin-right: 6px;
    margin-left: 6px;
  }
`;

export const FormItem = styled(Form.Item)`
  height: 85px;
  width: 100%;

  ${theme.formErrorMobileView}

  @media ${theme.breakpoints.mobileAndTablet} {
    height: 70px;
  }
`;
